module.exports = __webpack_public_path__ + "static/media/dvustranen_ukazaniq.f44ffa2c.pdf";